/**
 * UI state for lander vs offer dialogs in PathItemsSection.
 * For Media Devoted | Created By Ciro Autiero
 *
 * The full lander editor reads and writes the GLOBAL Voluum lander
 * (/voluum/landers/:id); TC uses its own guarded lander editor.
 */

import { useCallback, useState } from 'react';

import { tcEntityEditorEnabled } from '@/features/flow-optimizer/tracker-entities/identity';
import { useDrawerProfile, useFlowTracker } from '@/features/flow-optimizer/tracker';

import type { PathItemKind } from '../../../utils/path-item-display';

export type PathItemsUiState =
  | { tag: 'closed' }
  | { tag: 'simple'; mode: 'add' | 'edit'; index?: number }
  | { tag: 'lander'; index: number };

export function usePathItemsUi(kind: PathItemKind) {
  const [ui, setUi] = useState<PathItemsUiState>({ tag: 'closed' });
  const tcEditor = tcEntityEditorEnabled(useFlowTracker());
  const landerEditor = useDrawerProfile().voluumEntityApis || tcEditor;

  const onEditRow = useCallback(
    (idx: number) => {
      if (kind === 'landers' && landerEditor) setUi({ tag: 'lander', index: idx });
      else setUi({ tag: 'simple', mode: 'edit', index: idx });
    },
    [kind, landerEditor],
  );

  const close = useCallback(() => setUi({ tag: 'closed' }), []);

  return { ui, setUi, onEditRow, close };
}
